import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import NCListAdapterF from './NCListAdapter';
import JBrowse1TextSearchAdapterF from './JBrowse1TextSearchAdapter';
import JBrowse1ConnectionF from './JBrowse1Connection';
import GuessNCListF from './GuessNCList';
var LegacyJBrowsePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(LegacyJBrowsePlugin, _Plugin);
  function LegacyJBrowsePlugin() {
    var _this;
    _classCallCheck(this, LegacyJBrowsePlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LegacyJBrowsePlugin).apply(this, arguments));
    _this.name = 'LegacyJBrowsePlugin';
    return _this;
  }
  _createClass(LegacyJBrowsePlugin, [{
    key: "install",
    value: function install(pluginManager) {
      NCListAdapterF(pluginManager);
      GuessNCListF(pluginManager);
      JBrowse1TextSearchAdapterF(pluginManager);
      JBrowse1ConnectionF(pluginManager);
    }
  }]);
  return LegacyJBrowsePlugin;
}(Plugin);
export { LegacyJBrowsePlugin as default };